<div class="clearfix"></div>
<div class="limiter" id="login-area">
  <div class="container-login100">
    <div  style='text-align: center'>
      <p>Processing</p>   
    </div>
  </div>
</div>

